import { type CartItem } from '@cart-services/types'
import { type PropsWithChildren, createContext, useContext, useMemo } from 'react'
import { type OnQuantityChange } from './CouponProductSelectorItemVariationListProductItem'

export interface CouponProductSelectorContextProps {
  cartItems: CartItem[]
  onQuantityChange?: OnQuantityChange
  currency?: string
  isShowOriginalPrice?: boolean
}

const CouponProductSelectorContext = createContext<CouponProductSelectorContextProps>({
  cartItems: [],
})

export const CouponProductSelectorProvider = (props: PropsWithChildren<CouponProductSelectorContextProps>) => {
  const { cartItems, onQuantityChange, currency, isShowOriginalPrice, children } = props

  const contextValue = useMemo(() => ({
    cartItems,
    onQuantityChange,
    currency,
    isShowOriginalPrice,
  }), [cartItems, onQuantityChange, currency, isShowOriginalPrice])

  return (
    <CouponProductSelectorContext.Provider value={contextValue}>
      {children}
    </CouponProductSelectorContext.Provider>
  )
}

export const useContextCouponProductSelector = () => {
  const context = useContext(CouponProductSelectorContext)
  if (!context) {
    throw new Error('useContextCouponProductSelector must be used within a CouponProductSelectorProvider')
  }
  return context
}
